import { Button, Grid, useMediaQuery, useTheme } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import CachedIcon from "@material-ui/icons/Cached";
import SendIcon from "@material-ui/icons/Send";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import GlobitsNumberInput from "app/common/form/GlobitsNumberInput";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import { getCurrentStaff, isAdmin } from "app/common/LocalFunction";
import { renderOptionsStaff } from "app/PatientManagement/ReportRevenueDetail/ReportRevenueDetailSearch";
import { pagingClientAwardType } from "app/services/ClientAwardType";
import { pagingStaff } from "app/services/StaffService";
import { useStore } from "app/stores";
import { Form, Formik, useFormikContext } from "formik";
import { observer } from "mobx-react";
import { forwardRef, memo } from "react";
import { filterStaffOptions } from "utils";
import * as Yup from "yup";
import { renderOptionsClientAwardType } from "../Popup/LoyaltyPointsPopup";
const LoyaltyPointForm = ({
  handleSubmit,
  handleAfterSubmit,
  initialValues,
  patient,
  handleSetInitial,
  hasPermission
}) => {
  const currentStaff = getCurrentStaff();
  const validationSchema = Yup.object().shape({
    pointAmount: Yup.number()
      .required("Vui lòng nhập điểm")
      .typeError("Điểm phải là số")
      .max(100000, "Điểm không được vượt quá 100.000")
      .nullable(),

    clientAwardType: Yup.object()
      .nullable()
      .required("Chưa chọn hạng mục tích điểm!"),
  });
  return (
    <Formik
      initialValues={{
        patient,
        pointAccumulator: currentStaff,
        ...initialValues,
      }}
      validationSchema={validationSchema}
      onSubmit={async (values, { setSubmitting, resetForm }) => {
        await handleSubmit(values, { setSubmitting });
        if (handleAfterSubmit) {
          handleAfterSubmit();
          resetForm();
        }
      }}
      enableReinitialize
    >
      <Form autoComplete="off">
        <ValuesForm handleSetInitial={handleSetInitial} hasPermission={hasPermission} />
      </Form>
    </Formik>
  );
};
const ValuesForm = observer(({ handleSetInitial, hasPermission }) => {
  const { setFieldValue, values } = useFormikContext();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  const isAdminRole = isAdmin();

  return (
    <div
      style={{
        border: "1px solid #e5e7eb",
        borderRadius: "8px",
        padding: "8px",
      }}
    >
      <Grid container spacing={1} className="">
        <Grid item xs={12} sm={6} md={6}>
          <GlobitsDateTimePicker
            label={"Thời gian tích điểm"}
            name={"pointAccumulationTime"}
            isDateTimePicker
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <GlobitsPagingAutocomplete
            name={"pointAccumulator"}
            label={"Người tạo"}
            api={pagingStaff}
            displayLabel={"staffName"}
            searchObject={{
              isActive: true,
            }}
            ListboxComponent={forwardRef((props, ref) => {
              const { children, ...other } = props;
              return (
                <ul {...other} ref={ref}>
                  <ol>
                    <li>{children}</li>
                  </ol>
                </ul>
              );
            })}
            renderOption={(option) => renderOptionsStaff(option)}
            filterOptions={filterStaffOptions}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={6}>
          <GlobitsPagingAutocomplete
            name={"clientAwardType"}
            label={"Hạng mục tích điểm"}
            required
            api={pagingClientAwardType}
            onChange={(_, value) => {
              setFieldValue("clientAwardType", value);
              setFieldValue(
                "pointAmount",
                value?.awardPoint * (values?.quantity || 0)
              );
            }}
            ListboxComponent={forwardRef((props, ref) => {
              const { children, ...other } = props;
              return (
                <ul {...other} ref={ref}>
                  <ol className={"custom-listbox-client-award"}>
                    <li>{children}</li>
                  </ol>
                </ul>
              );
            })}
            renderOption={(option) => renderOptionsClientAwardType(option)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <GlobitsNumberInput
            label={"Số lượng"}
            name={"quantity"}
            onChange={(e) => {
              const quantity = +e.target.value;
              setFieldValue("quantity", quantity);
              setFieldValue(
                "pointAmount",
                values?.clientAwardType?.awardPoint * quantity
              );
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={6}>
          <GlobitsNumberInput
            label={"Điểm"}
            disabled={
              values?.clientAwardType?.systemCalculating && !isAdminRole
            }
            name={"pointAmount"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <GlobitsTextField
            label={"Ghi chú"}
            name={"note"}
            isTextArea
            row={3}
          />
        </Grid>
        {
          hasPermission &&
          <Grid item xs={12} sm={12} md={12}>
            <ImageFileComponent />
          </Grid>
        }


        {hasPermission &&
          <Grid item xs={12} sm={6} md={12} className="flex flex-end mt-2 gap-1">
            <Button
              variant="outlined"
              type="button"
              startIcon={
                <CachedIcon
                  size={16}
                  style={{
                    color: "#4276a4",
                  }}
                />
              }
              onClick={() => handleSetInitial()}
              className="action-btn-custom"
            >
              {!isMobile && "Làm mới"}
            </Button>
            <Button
              variant="outlined"
              type="submit"
              startIcon={
                <SendIcon
                  size={16}
                  style={{
                    color: "#4276a4",
                  }}
                />
              }
              className="action-btn-custom"
            >
              {!isMobile && "Tích điểm"}
            </Button>
          </Grid>
        }

      </Grid>
    </div>
  );
});

export const ImageFileComponent = observer(() => {
  const { handleUploadImages, setSelectedFile, selectedFile } =
    useStore().patientManagementStore.loyaltyPointsStore;

  return (
    <>
      <Grid item md={12}>
        <Grid container spacing={1}>
          <Grid item xs={4} md={3} style={{ position: "relative" }}>
            <div
              className="upload-add-box"
              onClick={() => {
                document.getElementById(`files-upload`)?.click();
              }}
            >
              <Add style={{ fontSize: 40, color: "#999" }} />
              <span>Thêm ảnh</span>
            </div>
            <input
              type="file"
              id="files-upload"
              multiple
              accept="image/*"
              onChange={(e) => {
                const files = Array.from(e?.target?.files);
                handleUploadImages(files);

                const input = document.getElementById("files-upload");
                if (input) input.value = "";
              }}
              style={{ display: "none" }}
            />
          </Grid>

          {selectedFile?.length > 0 &&
            selectedFile?.map((el, index) => (
              <Grid item xs={4} md={3}>
                <div className="image-preview-wrapper img-award">
                  <img
                    src={el?.fileDescription?.url}
                    alt={el?.fileDescription?.name}
                    className="preview-image"
                  />
                  <button
                    className="remove-button"
                    type="button"
                    onClick={() => {
                      let newSelectedFile = selectedFile?.filter(
                        (file) =>
                          file?.fileDescription?.id !== el?.fileDescription?.id
                      );
                      setSelectedFile(newSelectedFile);
                    }}
                  >
                    &times;
                  </button>
                </div>
              </Grid>
            ))}
        </Grid>
      </Grid>
    </>
  );
});

export default memo(observer(LoyaltyPointForm));
